import { useEffect, useState } from "react";
import { Divider } from "@mui/material";
import { allowedDeployCache } from "src/constants/role";
import {
  clearCacheFLFCustomer,
  deployCacheFLFCustomer,
  getCacheFLFCustomer,
} from "src/apis/FLF/customer.api";
import { currentUserHandleCache } from "src/utils/helper";
import useCurrentUserCache from "src/hooks/useCurrentUserCache";
import useAuth from "src/hooks/useAuth";
import {
  NotifyClearCache,
  NotifyDeployCache,
} from "src/components/notify/Notify";
import Controls from "src/components/form/controls/Controls";

const UpdateCache = ({ listDataCache, localUser, currentUserCache }) => {
  return (
    <div>
      <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
        {currentUserHandleCache(localUser, currentUserCache)}
        {`vừa cập nhật ${listDataCache.length} customer`}
      </p>
      {listDataCache.map((data, index) => (
        <p
          key={data.id}
          style={{ padding: "10px", fontWeight: "bold", color: "#d68102" }}
        >
          {`${index + 1}. ${data.fullname}`}
        </p>
      ))}
    </div>
  );
};

const objectActionCache = {
  Update: UpdateCache,
};

const RenderCache = ({
  listDataCache,
  actionCache,
  localUser,
  currentUserCache,
}) => {
  if (actionCache) {
    return objectActionCache[actionCache]({
      listDataCache,
      localUser,
      currentUserCache,
    });
  }
  return null;
};

const ShowCacheFLFCustomer = () => {
  const [listDataCache, setListDataCache] = useState([]);
  const [modelCache, setModelCache] = useState();
  const [actionCache, setActionCache] = useState();

  const { currentUserCache } = useCurrentUserCache();

  const { auth } = useAuth();

  useEffect(() => {
    getCacheFLFCustomer((result) => {
      setListDataCache(result.data);
      setModelCache(result.model);
      setActionCache(result.action);
    });
  }, []);

  const handleDeployData = () => {
    NotifyDeployCache(
      "warning",
      "Deploy Data ?",
      "<h5> Tất cả dữ liệu mới sẽ được lưu </h5>",
      (result) => {
        if (result.isConfirmed) {
          deployCacheFLFCustomer((result) => {
            window.location.reload(true);
          });
        }
      }
    );
  };

  const handleClearData = () => {
    NotifyClearCache(
      "warning",
      "Clear Cache ?",
      "<h5> Tất cả dữ liệu mới sẽ được hủy bỏ </h5>",
      (result) => {
        if (result.isConfirmed) {
          clearCacheFLFCustomer((result) => {
            window.location.reload(true);
          });
        }
      }
    );
  };

  return (
    <>
      <RenderCache
        listDataCache={listDataCache}
        modelCache={modelCache}
        actionCache={actionCache}
        localUser={auth}
        currentUserCache={currentUserCache}
      />
      <Divider sx={{ width: "100%" }} />
      {allowedDeployCache(
        currentUserCache?.email,
        auth?.email,
        auth?.permissions
      ) ? (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Controls.Button
            sx={{
              width: "150px",
              marginTop: "10px",
            }}
            color="secondary"
            type="button"
            text="Clear Cache"
            onClick={handleClearData}
          />
          <Controls.Button
            sx={{ width: "150px", marginTop: "10px", marginLeft: "10px" }}
            type="button"
            text="Deploy Data"
            onClick={handleDeployData}
          />
        </div>
      ) : null}
    </>
  );
};

export default ShowCacheFLFCustomer;
